/** READ-ONLY: TEK_RSI_MOMENTUM Trade Review (actual stored trades, never simulated). */
import api from "@/services/api";
import type { RsiTradeListFilters, RsiTradeListItem, RsiTradeReview } from "@/types";

const BASE = "/admin/strategies/rsi-momentum/trade-review";

export const rsiTradeReviewService = {
  async listTrades(filters: RsiTradeListFilters = {}): Promise<RsiTradeListItem[]> {
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== undefined && v !== ""));
    const { data } = await api.get<RsiTradeListItem[]>(`${BASE}/trades`, { params });
    return data;
  },

  async getTrade(id: string): Promise<RsiTradeReview> {
    const { data } = await api.get<RsiTradeReview>(`${BASE}/trades/${encodeURIComponent(id)}`);
    return data;
  },
};

export default rsiTradeReviewService;
